module.exports = __webpack_public_path__ + "media/images/redesign-images/home/home-apparel-large-3a5ee0a920d9f72d3fd88cbe83cb26f1.jpg";